<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Unit</v-toolbar-title>

		   <!--  <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field  v-model="Form.name" label="Unit" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('Unit name')" data-vv-name="Unit name" required></v-text-field>
	            </v-flex>
	            <v-flex xs12 sm12 md12 form-item v-if="false">
	               <v-text-field  v-model="Form.shortName" placeholder=" " label="Short Name"></v-text-field>
	            </v-flex>
	            <!-- <v-flex xs12 sm12 md12 form-item>
	               <v-text-field  type="number" v-model="Form.decimalPlaces" label="Decimal Places" placeholder=" " v-validate="'max_value:9'" :error-messages="errors.collect('decimal places')" data-vv-name="decimal places"></v-text-field>
	            </v-flex> -->

	            <v-flex xs12 sm12 md12 form-item @click="fn_openDialogUqc" v-if="$root.CurrentBusiness.GSTRegistrationStatus==1">
	               <v-text-field  
		               readonly 
		               v-model="Form.unitQuantityName" 
		               label="Unit Qty Code" 
		               placeholder=" " 
		               append-icon="arrow_drop_down"
		               v-validate="'required'"
		               :error-messages="errors.collect('uqc')" 
		               data-vv-name="uqc" 
		               data-vv-as="unit quantity code" 
		               required>
	               </v-text-field>
	            </v-flex>	            

			</v-layout>

			<!-- <v-layout wrap white-background margin-top-ten>
				<v-subheader full-width border-bottom-thin>Conversion Type</v-subheader>
			  	<v-flex xs12 sm12 md12 form-item>
		           	<v-radio-group v-model="Form.conversionType" row @change="fn_conversionType">
	               		<v-radio label="Nil" :value="101" :disabled="disableBaseUnit"></v-radio>
				      	<v-radio label="Fixed" :value="103"></v-radio>
				    </v-radio-group>
		        </v-flex>

	            <v-layout padding-bottom-ten wrap v-if="Form.conversionType!=101">
	            	<v-flex xs12 sm12 md12 form-item @click="fn_openUnitDialog('android', 'BaseUnit', 'field_baseUnit')">
		               <v-text-field  
		               	   :disabled="disableBaseUnit"
			               readonly 
			               v-model="Form.baseUnitName" 
			               label="Unit" 
			               placeholder=" " 
			               append-icon="arrow_drop_down"
			               v-validate="'required'"
			               ref="field_baseUnit" 
			               :onUpdate="fn_updateBaseUnit" 
			               :error-messages="errors.collect('Base Unit')" 
			               data-vv-name="Base Unit" 
			               required>
		               </v-text-field>
		            </v-flex>

		            <v-flex xs12 sm12 md12 v-if="Form.conversionType==103" form-item>
		               <v-text-field  type="number" v-model.number="Form.conversionQuantity" label="Conversion Quantity" placeholder=" " v-validate="'required|min_value:1|decimal:2'" :error-messages="errors.collect('Conversion Quantity')" data-vv-name="Conversion Quantity" required></v-text-field>
		            </v-flex>

	            </v-layout>

			</v-layout> -->

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>

		</v-form>

	    <!-- <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog> -->

	    <!-- <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar> -->

	    <!-- <dialog-discard ref="ref_dialogDiscard" :draftId="draftStorageId" :goBack="fn_goBack"></dialog-discard> -->
	    <dialog-uqc ref="ref_dialogUqc" :unitQuantityCodes="unitQuantityCodes" :selectedUqc="Form.unitQuantityCode" :updateUqc="fn_updateUqc"></dialog-uqc>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->


	</div>
</template>

<script>

const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;

import dialogUqc from './dialogs/dialog_uqc'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"unitId":null, "name":null, "shortName":null, "decimalPlaces":null, "baseUnitId":null, "baseUnitName":null, "conversionType":101, "conversionQuantity":null, "status":1, "unitQuantityCode":null, "unitQuantityName":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true},

				loading:false,
				tagId:null,
				dialogStorageId:null,
				draftStorageId:null,

				backButtonPress:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,
				unitQuantityCodes:require('../../../../config.js').configs.unitQuantityCodes,
				disableBaseUnit:false
			}
		},
		components:{
			'dialog-uqc': dialogUqc,
			'dialog-discard': dialogDiscard,
			// 'dialog-draft-items': dialogDraftItems
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
                    	this.fn_saveDraft(this.Form.name);
                    }
                    this.unwatch = false;
                },
                deep: true
            }
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogUqc: function(){
				this.fn_openDialogWeb('web', 'Uqc', 'ref_dialogUqc')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_updateUqc: function(item){
				this.Form.unitQuantityCode = item.id;
				this.Form.unitQuantityName = item.name;
				this.errors.remove('uqc');
				this.fn_closeDialog();
			},

			fn_conversionType: function(value){
				value != 103 ? this.Form.conversionQuantity=null : '';
			},

			fn_setUnitAsBase: function(val){
				this.Form.conversionType = 101;
				this.Form.conversionQuantity = null;
	          	this.Form.baseUnitName = null;
			},

			fn_openUnitDialog: function (platform, name, ref) {

				if(this.disableBaseUnit){
					return;
				}

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Units";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.baseUnitId && this.Form.baseUnitName){
					paramObject.defaultValue = {"id":this.Form.baseUnitId, "name":this.Form.baseUnitName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'Units', tagId, paramObject, ref);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_updateBaseUnit: function (selectedValueId, selectedValueName, isRemoved) {
				console.log(selectedValueId+':'+selectedValueName+':'+isRemoved);
				if(!isRemoved){
					this.Form.baseUnitId = selectedValueId;
		        	this.Form.baseUnitName = selectedValueName;
		        	this.errors.remove('Base Unit');
				}
				else{
					this.Form.baseUnitId = null;
		        	this.Form.baseUnitName = null;
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},
			
			fn_checkValidations: function(){
				var self = this;
			      this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			     });
			},
			
			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Units', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					// data.type = this.Form.conversionType == 101 ? 'unit' : 'subUnit';
					data.type = this.$route.query.unitType ? this.$route.query.unitType : 'unit'
					data.id = this.Form.unitId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("master_items_state")){
						let obj = JSON.parse(localStorage.getItem("master_items_state"));
						obj.itemId = self.Form.unitId;
						localStorage.setItem("master_items_state",JSON.stringify(obj));
					}

					self.$router.go(-1);
				});
			},
			
			fn_post: function(){

				this.Form.decimalPlaces ? this.Form.decimalPlaces = Number(this.Form.decimalPlaces) : this.Form.decimalPlaces = null;
				
				// !this.Form.unitId ? this.Form.unitId = this.guid() : '';

				if(!this.Form.unitId){
					this.Form.unitId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.name = this.Form.name.trim();
				
				this.Form.conversionType == 101 ? this.Form.baseUnitId = this.Form.unitId : '';

				this.Form.conversionType == 103 ? this.Form.conversionQuantity = Number(this.Form.conversionQuantity) : this.Form.conversionQuantity = null;

				if(this.Form.conversionType == 101){
					this.fn_setUnitAsBase();
				}

				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false;
				this.getData('Units', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          var itemData = JSON.parse(response);
				          self.unwatch = true;
				          self.Form.unitId = itemData.unitId;
				          self.Form.name = itemData.name;
				          self.Form.shortName == 'null' ? self.Form.shortName = null : self.Form.shortName = itemData.shortName;
				          self.Form.decimalPlaces = itemData.decimalPlaces;
				          self.Form.conversionType = itemData.conversionType

				          self.Form.conversionQuantity = itemData.conversionQuantity;

				          self.Form.baseUnitId = itemData.baseUnitId;
				          
				          if(itemData.conversionType!=101){
				          	self.Form.baseUnitName = itemData.baseUnit.name;
				          }

				          self.Form.unitQuantityCode = itemData.unitQuantityCode;

				          for(let i=0; i<self.unitQuantityCodes.length; i++){
				          	if(self.unitQuantityCodes[i].id == itemData.unitQuantityCode){
				          		self.Form.unitQuantityName = self.unitQuantityCodes[i].name;
				          		break;
				          	}
				          }

				          self.Form.isSystem = itemData.isSystem;

				          if(copyData){
				          	self.Form.unitId=null;
				          	self.Form.isSystem = 0;
				   //        	self.snackbar = true;
							// self.snackbar_msg = "Data copied."
							self.showToast("Data copied.");
				          }

				          self.$root.fn_copyFormObject(self.Form, self.formId);

				          console.log(self.Form);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			
			fn_clearForm: function(){
				this.Form = {"unitId":null, "name":null, "shortName":null, "decimalPlaces":null, "baseUnitId":null, "baseUnitName":null, "conversionType":101, "conversionQuantity":null, "status":1, "unitQuantityCode":null, "unitQuantityName":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true};
				this.$validator.reset();
			},
			
			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;

				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.unitId){
					this.fn_get(this.Form.unitId);
				}
				else{
					this.fn_clearForm();
				}
				
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
			},
			
			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Units";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;
				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "unit":
					    	this.fn_updateBaseUnit(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},
			
			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('unitforms')){
				formsArray = JSON.parse(localStorage.getItem('unitforms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('unitforms', JSON.stringify(formsArray));


			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			if(this.$route.query && this.$route.query.baseUnitId){
				this.Form.baseUnitId = this.$route.query.baseUnitId;
				this.Form.baseUnitName = this.$route.query.baseUnitName;
				this.Form.conversionType = 102;
				this.disableBaseUnit = true;
			}

			
			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Unit', true) : '';

				});

			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Unit');
			this.fn_setDraftData('temp', 'Unit');
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		else if(from.name=='unitItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'unitItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'unitDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}
		  		
		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}

		  	})
		},
		beforeRouteUpdate (to, from, next) {

			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('unitforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('unitforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('unitforms')
				// 	next();	
				// }
			}
	    }

	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/units/form.vue